import { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import AvatarViewer from "../components/viewers/AvatarViewer";
import { STATUS } from "../constants/avatar";
import AvatarProg from "./AvatarProg";
import AvatarSynced from "./AvatarSynced";
import { AvatarAction } from "../redux/actions/AvatarAction";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { AvatarConstant } from "../redux/reducers";

const AvatarFirstLoad = ({ avatarStatus, avatarPassword, avatarPasswordExpiredAt, UpdateAvatarToUserConfirm }) => {
  const [t] = useTranslation();
  const [isImportViewer, setIsImportViewer] = useState(false);
  const [allowPassword, setAllowPassword] = useState(false);
  const [isRequested, setIsRequested] = useState(false);
  const [exMessage, setExMessage] = useState("");
  const [isWrongImg, setIsWrongImg] = useState(false);
  const intervalRef = useRef({
    interval: null,
    startTime: null,
    lastStatus: null,
    checkTermTime: 1000 * 10,
    networkLimitTime: 1000 * 20,
    errorStatusLimitTime: 1000 * 60 * 60,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (avatarPassword) {
      const now = new Date().getTime();
      setAllowPassword(now < avatarPasswordExpiredAt);
    } else {
      setAllowPassword(false);
    }
  }, [avatarPassword, avatarPasswordExpiredAt])

  useEffect(() => {
    allowPassword && setIsImportViewer(true);
  }, [allowPassword]);

  useEffect(() => {
    if (avatarStatus === STATUS.SYNCED && !isRequested) {
      const cb = async () => {
        const avatarInfo = await AvatarAction.CheckAvatar();
        if (avatarInfo?.status === STATUS.SYNCED) {
          UpdateAvatarToUserConfirm();
          setIsRequested(true);
        }
      }
      cb();
    }
  }, [avatarStatus, isRequested]);

  useEffect(() => {
    let iv;
    if (!intervalRef.current?.interval) {
      setExMessage("");
      iv = intervalRef.current.interval = setInterval(async () => {
        const now = new Date().getTime();
        const avatarInfo = await AvatarAction.CheckAvatar();
        if (avatarInfo?.status === STATUS.PROGRESSING && avatarInfo.termsAt)  {
          if (now - avatarInfo.termsAt > intervalRef.current.errorStatusLimitTime) {
            setExMessage(i18next.t("\"Ray Virtual Smile\" could not be found, please create new one."));
            setIsWrongImg(true);
            clearInterval(iv);
            return;
          }
        }
        if (!intervalRef.current.startTime) {
          intervalRef.current.startTime = now;
        }
        if (intervalRef.current.lastStatus !== avatarInfo.status) {
          intervalRef.current.lastStatus = avatarInfo.status;
        }
        if (intervalRef.current.startTime && now - intervalRef.current.startTime > intervalRef.current.checkTermTime) {
          const availableStatus= [STATUS.PROGRESSING, STATUS.SYNCED];
          if (!availableStatus.includes(intervalRef.current.lastStatus) && intervalRef.current.lastStatus !== STATUS.CONFIRMED) {
            if (!intervalRef.current.lastStatus) {
              setExMessage(i18next.t("\"Ray Virtual Smile\" could not be found, please create new one."));
              setIsWrongImg(true);
            } else {
              setExMessage(i18next.t("Make sure RAYTeams is logged in."));
              setIsWrongImg(true);
            }
            clearInterval(iv);
          }
          if (intervalRef.current.lastStatus === STATUS.TERMS) {
            setExMessage(i18next.t("\"Ray Virtual Smile\" could not be found, please create new one."));
            setIsWrongImg(true);
            clearInterval(iv);
          }
          if (intervalRef.current.lastStatus === STATUS.SYNCED) {
            dispatch({ type: AvatarConstant.SET_AVATAR_STATUE, status: STATUS.SYNCED });
            clearInterval(iv);
          }
        }
        if (intervalRef.current.startTime && now - intervalRef.current.startTime > intervalRef.current.networkLimitTime) {
          setExMessage(i18next.t("Data uploads are delayed due to poor network connectivity"));
          clearInterval(iv);
        }
        if (intervalRef.current.lastStatus === STATUS.CONFIRMED) {
          clearInterval(iv);
        }
      }, 1000 * 5);
    }
    return () => {
      if (iv) {
        clearInterval(iv);
      }
    }
  }, [])


  return <div className="w-100 h-100">
    {avatarStatus === STATUS.PROGRESSING && <>
      <AvatarProg message={exMessage} isWrongImg={isWrongImg} />
    </>}
    {avatarStatus === STATUS.SYNCED && <>
      <AvatarViewer />
    </>}

    {/* {!isImportViewer && <>
      {avatarStatus === STATUS.PROGRESSING && <>
        <AvatarProg />
      </>}
      {avatarStatus === STATUS.SYNCED && <>
        <AvatarSynced />
      </>}
    </>}
    {isImportViewer && <>
      <AvatarViewer />
    </>} */}
  </div>
};

const mapState = (state) => {
  const avatarStatus = state.AvatarReducer.status;
  const avatarPassword = state.AvatarReducer.password;
  const avatarPasswordExpiredAt = state.AvatarReducer.passwordExpiredAt;
  return { avatarStatus, avatarPassword, avatarPasswordExpiredAt };
};

const mapDispatch = dispatch => ({
  UpdateAvatarToUserConfirm: () => dispatch(AvatarAction.UpdateAvatarToUserConfirm()),
});

export default connect(mapState, mapDispatch)(AvatarFirstLoad);
